<template>
  <v-container fluid="fluid" grid-list-md="grid-list-md">
    <Create :createDialog="createDialog" @close="close" @createdLead="createdLead"> </Create>
    <Edit :editDialog="editDialog" @close="closeEdit" @updatedLead="updatedLead" :lead="lead">
    </Edit>
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t("labels.filters") }}</h1>
        </v-toolbar-title>
        <v-spacer> </v-spacer>
        <v-tooltip class="ml-1 pointer" bottom="bottom">
          <template v-slot:activator="{ on }">
            <v-btn flat="flat" v-on="on" @click="reset" icon="icon">
              <v-icon>autorenew</v-icon>
            </v-btn>
          </template>
          <span>Reset</span>
        </v-tooltip>
        <v-tooltip class="ml-1 pointer" bottom="bottom">
          <template v-slot:activator="{ on }">
            <v-btn flat="flat" v-on="on" @click="reloadData" icon="icon">
              <v-icon>refresh</v-icon>
            </v-btn>
          </template>
          <span>Fetch Data</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-layout row="row" wrap="wrap">
          <v-flex xs6="xs6" sm4="sm4">
            <v-select
              v-model="filter.assignedTo"
              :items="AssignedUser"
              name="assigned-user"
              :loading="assignedLoading"
              clearable="clearable"
              item-text="fullName"
              item-value="userID"
              attach="attach"
              chips="chips"
              label="Assigned To"
              multiple="multiple"
            >
              <template slot="selection" slot-scope="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.fullName }}</span>
                </v-chip>
                <span class="grey--text caption" v-if="index === 1"
                  >(+{{ filter.assignedTo.length - 1 }} others)</span
                >
              </template>
            </v-select>
          </v-flex>
          <v-flex xs6="xs6" sm4="sm4">
            <v-select
              v-model="filter.softwareID"
              :items="comboBoxByID(3).ComboBoxDetails"
              clearable="clearable"
              :label="$t('labels.software')"
              item-text="selector"
              item-value="id"
              attach="attach"
              chips="chips"
              multiple="multiple"
            >
              <template slot="selection" slot-scope="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.selector }}</span>
                </v-chip>
                <span class="grey--text caption" v-if="index === 1"
                  >(+{{ filter.ticketType.length - 1 }} others)</span
                >
              </template>
            </v-select>
          </v-flex>
          <v-flex xs6="xs6" sm4="sm4">
            <v-select
              v-model="filter.status"
              :items="comboBoxByID(7).ComboBoxDetails"
              clearable="clearable"
              :label="$t('labels.status')"
              item-text="selector"
              item-value="id"
              attach="attach"
              chips="chips"
              multiple="multiple"
            >
              <template slot="selection" slot-scope="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.selector }}</span>
                </v-chip>
                <span class="grey--text caption" v-if="index === 1"
                  >(+{{ filter.status.length - 1 }} others)</span
                >
              </template>
            </v-select>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-card class="mt-2">
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t("pageHeader.leads") }}</h1>
        </v-toolbar-title>
        <v-btn
          color="teal"
          dark="dark"
          small="small"
          absolute="absolute"
          bottom="bottom"
          right="right"
          fab="fab"
          @click="add"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title>
        <v-flex xs12 sm4="sm4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line="single-line"
            hide-details="hide-details"
          >
          </v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        item-key="id"
        :items="leads"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr class="pointer" @click="props.expanded = !props.expanded">
            <td class="text-xs-left" v-html="$options.filters.highlight(props.item.id, search)">{{ props.item.id }}</td>
            <td class="text-xs-left" v-html="$options.filters.highlight(props.item.firstName, search)">{{ props.item.firstName }}</td>
            <td class="text-xs-left" v-html="$options.filters.highlight(props.item.businessName, search)">{{ props.item.businessName }}</td>
            <td class="text-xs-left" v-html="$options.filters.highlight(props.item.phoneNumber, search)">{{ props.item.phoneNumber | USPhoneNumber }}</td>
            <td class="text-xs-left">
              <StatusIndicator
                class="mr-2"
                negative="negative"
                pulse="pulse"
                v-if="
                  $moment(props.item.dueDate).format('MM/DD/YYY 23:59:59') <
                    $moment().format('MM/DD/YYYY 23:59:59')
                "
              >
              </StatusIndicator>
              <span>{{ props.item.assignedToUser.fullName }}</span>
            </td>
            <td class="text-xs-left">{{ $moment(props.item.dueDate).format("MM/DD h:m a") }}</td>
            <td class="text-xs-left" v-html="$options.filters.highlight(props.item.statusDetail.selector, search)">{{ props.item.statusDetail.selector }}</td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-card>
            <v-card-text>
              <v-card class="elevation-15" dark color="#1B1B1D">
                <v-container grid-list-md>
                  <v-layout row="row" wrap="wrap">
                    <v-flex xs12 sm6>
                      <h3 class="font-weight-bold mb-2" style="color: #21C593;">Lead</h3>
                      <div class="font-weight-bold">{{ $t("labels.createdAt") }}</div>
                      <div>
                        {{ $moment(props.item.createdAt).format("MM/DD/YYYY h:m a") }}
                      </div>
                      <div class="mt-1 font-weight-bold">{{ $t("labels.businessName") }}</div>
                      <div>{{ props.item.businessName }}</div>

                      <h3 class="font-weight-bold mb-2 mt-3" style="color: #21C593;">Address</h3>
                      <div>
                        <span class="font-weight-bold mt-1 "
                          >{{ $t("labels.streetAddress") }}: </span
                        >
                        <span>{{ props.item.businessName }}</span>
                      </div>
                      <div>
                        <span class="mt-1 font-weight-bold">{{ $t("labels.city") }}: </span>
                        <span>{{ props.item.city }}</span>
                      </div>
                      <div>
                        <span class="mt-1 font-weight-bold">{{ $t("labels.state") }}: </span>

                        <span>{{ props.item.state }}</span>
                      </div>
                      <div>
                        <span class="mt-1 font-weight-bold">{{ $t("labels.zipCode") }}: </span>

                        <span>{{ props.item.zipcode }}</span>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <h3 class="font-weight-bold mb-2" style="color: #21C593;">Contact</h3>
                      <div>
                        <span class="mt-1 font-weight-bold">{{ $t("labels.name") }}: </span>

                        <span>{{ props.item.firstName }} {{ props.item.lastName }}</span>
                      </div>
                      <div>
                        <span class="mt-1 font-weight-bold">{{ $t("labels.phoneNumber") }}: </span>

                        <span>{{ props.item.phoneNumber | USPhoneNumber }}</span>
                      </div>
                      <div>
                        <span class="mt-1 font-weight-bold">{{ $t("labels.emailAddress") }}: </span>

                        <span>{{ props.item.email }}</span>
                      </div>
                      <div>
                        <span class="mt-1 font-weight-bold">{{ $t("labels.locationCount") }}: </span>

                        <span>{{ props.item.locationCount }}</span>
                      </div>
                      <h3 class="font-weight-bold mb-2 mt-3" style="color: #21C593;">Note</h3>
                      <div>{{ props.item.notes }}</div>
                    </v-flex>
                    <v-layout row="row" wrap="wrap">
                      <v-btn color="info" @click="gotoPage(props.item)">Go to page</v-btn>
                      <v-btn color="info" flat="flat" @click="gotoPageNewTab(props.item)">
                        <v-icon left="left">open_in_new </v-icon>Open in new tab</v-btn
                      >
                      <v-spacer> </v-spacer>
                      <v-btn color="pink" dark="dark" icon="icon" @click="edit(props.item)">
                        <v-icon small="small">edit </v-icon>
                      </v-btn>
                      <v-btn color="red" dark="dark" icon="icon" @click="removeLead(props.item)">
                        <v-icon small="small">delete </v-icon>
                      </v-btn>
                    </v-layout>
                  </v-layout>
                </v-container>
              </v-card>
            </v-card-text>
          </v-card>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import leadService from "../service.js";
import userService from "../../User/service.js";
import { StatusIndicator } from "vue-status-indicator";
const Create = () => import("./Create");
const Edit = () => import("./Edit");
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      createDialog: false,
      lead: null,
      editDialog: false,
      filter: {
        assignedTo: [],
        status: []
      },
      AssignedUser: [],
      assignedLoading: true,
      headers: [
        {
          text: this.$t("labels.leadNumber"),
          value: "id",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.name"),
          value: "firstName",
          sortable: true
        },
        {
          text: this.$t("labels.businessName"),
          value: "businessName",
          sortable: true
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "phoneNumber",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.assignedTo"),
          value: "assignedToUser.fullName",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.followOn"),
          value: "dueDate",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.status"),
          value: "statusDetail.selector",
          sortable: true,
          width: "10%"
        }
      ],
      search: null,
      leads: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "id",
        descending: true
      }
    };
  },
  computed: {
    ...mapGetters("global", ["comboBox", "ComboBox", "comboBoxByID", "currentUser"])
  },
  async created() {
    await this.getAllUsers();
    await this.resetList();
    await this.getList();
  },
  components: {
    Create,
    Edit,
    StatusIndicator
  },
  methods: {
    gotoPageNewTab(data) {
      let routeData = this.$router.resolve({ path: `/leads/profile/${data.id}` });
      window.open(routeData.href, "_blank");
    },
    removeLead(lead) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          return leadService
            .delete(lead.id)
            .then(response => {
              if (response.data) {
                this.$swal
                  .mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000
                  })
                  .fire({
                    type: "success",
                    title: "Lead has been deleted"
                  });
                this.$Progress.finish();
                this.getList();
              }
            })
            .catch(error => {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "error",
                  title: err.data.message
                });
              this.$Progress.fail();
            });
        }
      });
    },
    add() {
      this.createDialog = true;
    },
    close() {
      this.createDialog = false;
    },
    closeEdit() {
      this.editDialog = false;
    },
    createdLead() {
      this.close();
      this.getList();
    },
    updatedLead() {
      this.closeEdit();
      this.getList();
    },
    edit(data) {
      this.lead = data;
      this.editDialog = true;
    },
    updated() {
      this.editDialog = false;
      this.getList();
    },
    gotoPage(data) {
      this.$router.push({ path: `/leads/profile/${data.id}` });
    },
    reset() {
      this.resetList();
      this.getList();
    },
    resetList() {
      this.filter.status = [];
      this.filter.status.push(27);
      this.filter.status.push(94);
      this.filter.assignedTo = [];
      this.filter.assignedTo.push(this.currentUser.userID);
    },
    getAllUsers() {
      return userService.getAllCrmUser().then(result => {
        this.AssignedUser = result.data;
        this.assignedLoading = false;
        this.filter.assignedTo.push(this.currentUser.userID);
      });
    },
    reloadData() {
      this.loading = true;
      let proFilter = {};
      if (this.filter.assignedTo.length > 0)
        proFilter.assignedTo = this.filter.assignedTo.toString();
      if (this.filter.status.length > 0) proFilter.status = this.filter.status.toString();
      return leadService.getAll(proFilter).then(response => {
        this.leads = response.data;
        this.loading = false;
        return response;
      });
    },
    getList() {
      console.log("this.currentUser", this.currentUser.userID);
      this.loading = true;
      let proFilter = {
        assignedTo: this.filter.assignedTo.toString(),
        status: this.filter.status.toString()
      };
      console.log("proFilter", proFilter);
      leadService.getAll(proFilter).then(response => {
        console.log("leads response", response);
        this.leads = response.data;
        this.loading = false;
      });
    }
  }
};
</script>
